module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-BEHANCE.6b04601f.png";